import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ProofImageViewer = ({ imageUrl, imageAlt, onPrevious, onNext, hasPrevious, hasNext }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [touchStart, setTouchStart] = useState(null);

  const handleTouchStart = (e) => {
    setTouchStart(e?.touches?.[0]?.clientX);
  };

  const handleTouchEnd = (e) => {
    if (!touchStart) return;

    const touchEnd = e?.changedTouches?.[0]?.clientX;
    const diff = touchStart - touchEnd;

    if (Math.abs(diff) > 50) {
      if (diff > 0 && hasNext) {
        onNext();
      } else if (diff < 0 && hasPrevious) {
        onPrevious();
      }
    }

    setTouchStart(null);
  };

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  return (
    <div
      className="relative w-full h-[300px] md:h-[400px] lg:h-[500px] bg-muted rounded-lg overflow-hidden"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className={`w-full h-full transition-gaming cursor-zoom-in ${
          isZoomed ? 'cursor-zoom-out' : ''
        }`}
        onClick={toggleZoom}
      >
        <Image
          src={imageUrl}
          alt={imageAlt}
          className={`w-full h-full transition-gaming ${
            isZoomed ? 'object-contain scale-150' : 'object-cover'
          }`}
        />
      </div>
      {hasPrevious && (
        <button
          onClick={(e) => {
            e?.stopPropagation();
            onPrevious();
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-background/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-gaming-md transition-gaming active:translate-y-px z-10"
          aria-label="Previous proof"
        >
          <Icon name="ChevronLeft" size={24} color="var(--color-foreground)" />
        </button>
      )}
      {hasNext && (
        <button
          onClick={(e) => {
            e?.stopPropagation();
            onNext();
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-background/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-gaming-md transition-gaming active:translate-y-px z-10"
          aria-label="Next proof"
        >
          <Icon name="ChevronRight" size={24} color="var(--color-foreground)" />
        </button>
      )}
      <div className="absolute bottom-4 right-4 px-3 py-2 bg-background/90 backdrop-blur-sm rounded-md flex items-center space-x-2">
        <Icon name={isZoomed ? 'ZoomOut' : 'ZoomIn'} size={16} color="var(--color-foreground)" />
        <span className="text-xs text-foreground caption">
          {isZoomed ? '축소하려면 클릭' : '확대하려면 클릭'}
        </span>
      </div>
    </div>
  );
};

export default ProofImageViewer;